import { useMutation } from '@tanstack/react-query'
import { useAccessToken } from '../../useAccessToken'
import { useCallback } from 'react'
import { FetchResponse, makeResultFetch } from '../../genericFetch'
import { apiRequestParams } from '../../fetchOptions'
import { useHandleError } from '../../useHandleError'

export const useDeleteProjectCache = () => {
  const getAccessToken = useAccessToken()
  const handleError = useHandleError()

  const mutationFunction = useCallback(
    async (projectId: string) => {
      return getAccessToken().then((accessToken) => {
        if (!accessToken) throw new Error('Access token is undefined')

        const fetchedData = makeResultFetch<boolean>(
          `/Cache/Projects/${projectId}`,
          apiRequestParams(accessToken, 'DELETE')
        ).then((response: FetchResponse<boolean>) => {
          const { message, success } = response

          if (!success) throw Error(message)

          return response
        })

        return fetchedData
      })
    },
    [getAccessToken]
  )

  const handleSuccess = (response: FetchResponse<boolean>) => {
    if (response.success) {
      alert(`Projektcache har tagits bort`)
    }
  }

  const deleteProjectCache = useMutation({
    mutationFn: mutationFunction,
    onSuccess: handleSuccess,
    onError: handleError,
  })

  return deleteProjectCache
}
